import request from '../../utils/request'
import axios from 'axios';

// 获取用户列表信息
export const getUserList = (data) => {
  return request({
    url: `/api/admin/users/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&keyword=${data.keyword}`,
    method: 'get'
  })
}

/**
 * 导出用户列表（不依赖外部封装的 request）
 * @returns {Promise} - 返回二进制文件流（Blob）的 Promise
 */
export const exportUser = () => {
  // 基础配置（如 baseURL、超时时间、请求头）
  const baseConfig = {
    baseURL: 'https://www.xianyut.com', 
    timeout: 30000, // 超时时间（30秒，导出可能耗时较长）
    headers: {
      // 若需要认证，添加 Token（根据实际场景调整）
      'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  };

  // 创建 axios 实例（避免污染全局配置）
  const instance = axios.create(baseConfig);

  // 发起 GET 请求（导出接口常用 GET，参数通过 params 传递）
  return instance({
    url: '/api/admin/users/export', // 接口完整路径（baseURL + url 拼接）
    method: 'get',
    responseType: 'blob' // 关键：声明响应为二进制流（Blob）
  });
};